import BikeSvg from '@assets/images/svg/bike.svg';
import React from 'react';
import { View } from 'react-native';

export interface BikeIconProps {
    size?: number;
    color?: string;
}

export function BikeIcon({ size = 24, color = '#4D4D4D' }: BikeIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <BikeSvg width={size} height={size} color={color} />
        </View>
    );
}

export default BikeIcon;
